import React from 'react'
import NavLink from '../Routes/NavLink'
import moment from 'moment'
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import { browserHistory, match } from 'react-router';

import { workOrders } from '../../core/controllers/WorkOrders';
import { user } from '../../core/controllers/user';
import { modal } from '../../core/utilities/modal';

export default class WorkOrdersList extends React.Component {
    constructor(props) {
        super(props);
        this.mobileTarget =
            window.matchMedia(
                "(min-width: 700px)"
            ); /* Retain the target so the event listener can be 
                    unmounted */
        this.hideTasksListener = (event) => {
            // Define the event lister
            if (event.matches) {
                // Window has gone from desktop to mobile view
                this.setState({
                    mobileView: true,
                });
            } else {
                // mobile to desktop
                this.setState({
                    mobileView: false,
                });
            }
        };
        this.mobileTarget.addEventListener("change", this.hideTasksListener);
        this.state = {
            workOrders: {},
            orderFilter: "All",
            orderSort: props.sortOptions,
            mobileView: this.mobileTarget.matches,
        };

        this.index = 0;
    }

    componentDidMount() {
        var self = this;
        workOrders.getWorkOrders(this.state.orderFilter, this.state.orderSort, function(response){
            if(response.data.length > 0) {
                self.setState({
                    workOrders: response.data
                });
            }
        });

        if(user.userInfo == null) {
            user.getUserDataWithCallback(function() {
                self.forceUpdate();
            });
        }
    }

    componentWillUnmount() {
        this.mobileTarget.removeEventListener("change", this.hideTasksListener) 
    }

    componentWillUpdate(nextProps, nextState) {
        var self = this;

        this.index = 0;
        if(nextProps.orderFilter !== nextState.orderFilter) {
            nextState.orderFilter = nextProps.orderFilter;
            workOrders.getWorkOrders(nextState.orderFilter, this.state.orderSort, function(response){
                if(response.data.length > 0) {
                    self.setState({
                        workOrders: response.data
                    });
                }
            });
        }
    }

    componentDidUpdate() {

    }

    formatSubmittedDate(cell, row) {
        return moment.utc(cell).local().format('D MMM YYYY h:mm A');
    }

    simpleFormatSubmittedDate(cell, row) {
        return moment(cell).format('MMM Do YYYY');
    }

    formatBuildingLink(cell, row) {
        if(cell !== null) {
            if(row.building_level != 0) {
                return <NavLink to={row.building_link}>{cell} - Level {row.building_level}</NavLink>
            } else {
                return <NavLink to={row.building_link}>{cell}</NavLink>
            }
        } else {
            return 'None';
        }
    }

    formatPropertyName(cell, row) {
        if(cell !== null) {
            return (
            <span onClick={this}>
                <NavLink to={"/properties/" + row.property_id}>{cell}</NavLink>
            </span>
            )
        } else {
            return 'None';
        }
    }

    formatContractorLink(cell, row) {
        if(row.assignee_id != "0" && row.assignee_data != null) {
            return (
            <span class="contractor-info" onClick={this}>
                <span onClick={modal.showSuccess.bind(modal, 'Contractor Information', 'Firstname: ' + row.assignee_data.firstname + '</br>Lastname: ' + row.assignee_data.lastname + '</br>Phone: ' + row.assignee_data.phone + '</br>Company: ' + row.assignee_data.company + '</br>Email: ' + row.assignee_data.email, <NavLink to={"/user/" + row.assignee_id} />, 'Edit User')}>{row.assignee_data.company}</span>
            </span>
            )
        } else {
            return 'Not Assigned';
        }
    }

    formatIndexColumn(cell, row) {
        ++this.index;
        return this.index;
    }

    formatLease(cell, row) {
        if(row.contract != null) {
            return <NavLink to={'/lease/' + row.contract.contract_id}>{row.contract_data.title}</NavLink>
        } else {
            return 'No Lease';
        }
    }

    formatTenant(cell, row) {
        if (row.tenant != null) {
            return (
            <span onClick={this}>
                <NavLink to={'/tenant/' + row.tenant_id}>{row.tenant.tenant_firstname} {row.tenant.tenant_lastname}</NavLink>
            </span>
            )
        }
        return 'No Tenant'
    }

    didSelectRow(row) {
        browserHistory.push('/maintenance/order/' + row.work_order_id);
    }

    stopSelectRow(e) {
        e.stopPropagation();
    }

    render(){
        const workOrders = this.state.workOrders;
        const userType = user.userInfo ? user.userInfo.user_type_alias : null;
        const mobileView = this.state.mobileView;
        const options = {
            onRowClick: this.didSelectRow,
            sizePerPage: 25
        };

        if (userType !== null && userType !== 'contractor' && this.props.tableType != 'widget') {
            if (userType === 'tenant' && this.props.tableType == 'dashboard') {
                return (
                    <div class="row">
                        <div class="content">
                        {workOrders.length > 0 ? (
                            <div>
                                <BootstrapTable data={workOrders} version='4' options={options} striped search pagination>
                                    <TableHeaderColumn dataField='id' width="50" hidden={!mobileView} dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true }></TableHeaderColumn>
                                    <TableHeaderColumn dataField='work_order_title' dataSort={ true }>Title</TableHeaderColumn>
                                    <TableHeaderColumn dataField='order_status' dataSort={ true }>Status</TableHeaderColumn>
                                    <TableHeaderColumn dataField='created_at' dataFormat={this.formatSubmittedDate} dataSort={ true }>Request Date</TableHeaderColumn>
                                </BootstrapTable>
                                <div class="row">
                                    <NavLink to={"/maintenance"}>
                                        <button type="button" data-loading-text="Loading..." class="add-tenant btn btn-info btn-fill pull-right" autoComplete="off">View All Maintenance</button>
                                    </NavLink>
                                </div>
                            </div>
                        ) : (
                            <div>
                                <h3><b>No Requests Yet</b></h3>
                                <NavLink to={"/maintenance/order/new"}>
                                    <button type="button" id="add-work-order" data-loading-text="Loading..." class="add-tenant btn btn-info btn-fill" autoComplete="off">Submit Request</button>
                                </NavLink>
                            </div>
                        )}
                        </div>
                    </div>
                )
            } 
            else 
            {
                return (
                    <div class="row">
                        <div class="content">
                        {workOrders.length > 0 ? (
                            window.innerWidth < 992 ? (
                            <BootstrapTable data={workOrders} options={options} version='4' striped search pagination>
                                <TableHeaderColumn dataField='id' width="50" hidden={!mobileView} dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true }></TableHeaderColumn>
                                <TableHeaderColumn dataField='work_order_title' dataSort={ true }>Title</TableHeaderColumn>
                                <TableHeaderColumn dataField='order_status' dataSort={ true }>Status</TableHeaderColumn>
                                <TableHeaderColumn dataField='order_priority' dataSort={ true }>Priority</TableHeaderColumn>
                                <TableHeaderColumn dataField='assignee_name' dataFormat={this.formatContractorLink.bind(this.stopSelectRow)} dataSort={ true }>Assigned</TableHeaderColumn>
                            </BootstrapTable>
                            ) : (
                            <BootstrapTable data={workOrders} options={options} version='4' striped search pagination>
                                <TableHeaderColumn dataField='id' width="50" hidden={!mobileView} dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true }></TableHeaderColumn>
                                <TableHeaderColumn dataField='work_order_title' dataSort={ true }>Title</TableHeaderColumn>
                                <TableHeaderColumn dataField='order_status' dataSort={ true }>Status</TableHeaderColumn>
                                <TableHeaderColumn dataField='order_priority' dataSort={ true }>Priority</TableHeaderColumn>
                                <TableHeaderColumn dataField='tenant_lastname' dataFormat={this.formatTenant.bind(this.stopSelectRow)} dataSort={ true }>Tenant</TableHeaderColumn>
                                <TableHeaderColumn dataField='property_name' dataFormat={this.formatPropertyName.bind(this.stopSelectRow)} dataSort={ true }>Property</TableHeaderColumn>
                                <TableHeaderColumn dataField='assignee_name' dataFormat={this.formatContractorLink.bind(this.stopSelectRow)} dataSort={ true }>Assigned</TableHeaderColumn>
                                <TableHeaderColumn dataField='created_at' dataFormat={this.formatSubmittedDate} dataSort={ true }>Submitted</TableHeaderColumn>
                            </BootstrapTable>
                            )
                        ) : (
                            <p>No maintenance requests.</p>
                        )}
                        </div>
                    </div>
                )
            }
        } 
        else if(this.props.tableType != 'widget')
        {
            return (
                <div class="row">
                    <div class="content">
                    {workOrders.length > 0 ? (
                        window.innerWidth < 992 ? (
                            <BootstrapTable data={workOrders} version='4' options={options} striped search pagination>
                            <TableHeaderColumn dataField='id' width="50" hidden={!mobileView} dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true }></TableHeaderColumn>
                            <TableHeaderColumn dataField='work_order_title' dataSort={ true }>Title</TableHeaderColumn>
                            <TableHeaderColumn dataField='order_status' dataSort={ true }>Status</TableHeaderColumn>
                            <TableHeaderColumn dataField='order_priority' dataSort={ true }>Priority</TableHeaderColumn>
                        </BootstrapTable>
                        ) : (
                        <BootstrapTable data={workOrders} version='4' options={options} striped search pagination>
                            <TableHeaderColumn dataField='id' width="50" hidden={!mobileView} dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true }></TableHeaderColumn>
                            <TableHeaderColumn dataField='work_order_title' dataSort={ true }>Title</TableHeaderColumn>
                            <TableHeaderColumn dataField='order_status' dataSort={ true }>Status</TableHeaderColumn>
                            <TableHeaderColumn dataField='order_priority' dataSort={ true }>Priority</TableHeaderColumn>
                            <TableHeaderColumn dataField='building_name' dataFormat={this.formatPropertyName.bind(this.stopSelectRow)} dataSort={ true }>Property</TableHeaderColumn>
                            <TableHeaderColumn dataField='created_at' dataFormat={this.formatSubmittedDate} dataSort={ true }>Submitted</TableHeaderColumn>
                        </BootstrapTable>
                        )
                    ) : (
                        <p>No maintenance requests.</p>
                    )}
                    </div>
                </div>
            )
        } 
        else 
        {
            return (
                <div class="row">
                    <div class="content">
                    {workOrders.length > 0 ? (
                        window.innerWidth < 992 ? (
                        <BootstrapTable data={workOrders} options={options} striped pagination version='4'>
                            <TableHeaderColumn width="50" dataField='id' hidden={!mobileView} columnClassName="table-index" dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true }></TableHeaderColumn>
                            <TableHeaderColumn dataField='work_order_title' dataSort={ true }>Title</TableHeaderColumn>
                            <TableHeaderColumn dataField='order_priority' dataSort={ true }>Priority</TableHeaderColumn>
                        </BootstrapTable>
                        ) : (
                        <BootstrapTable data={workOrders} options={options} striped pagination version='4' height="380px">
                            <TableHeaderColumn width="50" dataField='id' hidden={!mobileView} columnClassName="table-index" dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true }></TableHeaderColumn>
                            <TableHeaderColumn dataField='work_order_title' dataSort={ true }>Title</TableHeaderColumn>
                            <TableHeaderColumn dataField='order_status' dataSort={ true }>Status</TableHeaderColumn>
                            <TableHeaderColumn dataField='order_priority' dataSort={ true }>Priority</TableHeaderColumn>
                            <TableHeaderColumn dataField='created_at' dataFormat={this.simpleFormatSubmittedDate} dataSort={ true }>Created</TableHeaderColumn>
                        </BootstrapTable>
                        )
                    ) : (
                        <p>No new maintenance requests.</p>
                    )}
                    </div>
                </div>
            )
        }
    }
};


// WEBPACK FOOTER //
// app/components/WorkOrders/WorkOrdersList.jsx